import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const SubCategoryName = styled.p`
  margin: 0;
  padding: 0;
  ${fontStyles}
`;

export const FiltersContainer = styled.div`
  padding: 1.375rem;
  background: #f0f8fb;
  border-bottom: 1px solid #ccc;
`;

export const FiltersTitle = styled.h2`
  margin: 0;
  padding: 0;
  color: #004c83;
  font-style: italic;
  text-transform: initial;
  ${fontStyles}
`;

export const FiltersWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1.25rem;
  margin: 1rem 0;
`;

export const FiltersBtnWrapper = styled.div`
  text-align: right;
`;

export const FilterOption = styled.div`
  input[type="checkbox"] {
    vertical-align: middle;
    margin: 0;
  }
  label {
    ${fontStyles}
    width: auto;
    margin: 0;
    font-size: 0.875rem;
    display: inline;
  }
  &:first-child {
    margin: 0;
  }
  &:last-child {
    margin: 0;
  }
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;

export const FiltersLabel = styled.label`
  ${fontStyles}
  color: #1bace4;
  font-size: 0.875rem;
  text-transform: initial;
  margin: 0;
  padding: 0;
`;

export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;

export const CentreProductsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
  input[type="checkbox"] {
    vertical-align: middle;
    margin: 0;
  }
  label {
    ${fontStyles}
    width: auto;
    margin: 0;
    font-size: 0.875rem;
    display: inline;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1.25rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const APIErrorMEssage = styled.span`
  ${fontStyles}
  color: red;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const OptionLabel = styled.h2`
  ${fontStyles}
  font-weight: 700;
  font-size: 1.25rem;
  color: #ff9800;
  margin: 0 0 0.75rem 0;
  padding: 0;
  border-bottom: 1px solid #ddd;
  text-transform: initial;
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const TransportSection = styled.div`
  margin-top: 2.25rem;
`;

export const CommentsContainer = styled.section`
  margin-bottom: 1.875rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
`;

export const PollutionParamsGoodMessage = styled.span`
  ${fontStyles}
  color: green;
  font-size: 0.75rem;
`;

export const PollutionParamsErrorMessage = styled.span`
  ${fontStyles}
  color: #ed6b08;
  font-size: 0.75rem;
`;

export const PollutionParamsTableContainer = styled.div`
  background: #c9e8fb;
  border-radius: 4px;
  margin-bottom: 2.063rem;
  padding: 0.625rem;

  > table {
    width: 100%;
  }
  > table tbody tr td {
    ${fontStyles}
    padding: 1rem !important;
    color: #000;
    background-color: #c9e8fb;
    height: auto;
  }
  > table thead tr td {
    ${fontStyles}
    color: #1bace4;
    padding: 1rem !important;
    background-color: #c9e8fb;
    height: auto;
  }
  > table tbody tr td > div {
    margin-bottom: 0.5rem;
  }
  > table tbody .parameter-name {
    font-weight: bold;
  }
  > table tbody .parameter-separator {
    margin: 0 0.313rem;
  }
`;

export const EditOptionsLabel = styled.h2`
  ${fontStyles}
  color: #1bace4;
  text-transform: initial;
  margin: 0 0 0.563rem 0;
`;

export const EditOptionsPreDefinedDescription = styled.pre`
  ${fontStyles}
  color: #000000;
  background-color: transparent;
  padding: 0.625rem;
  overflow: auto;
  border: 1px solid #ccc;
`;

export const EditOptionsDescription = styled.p`
  ${fontStyles}
  color: #000000;
  background-color: transparent;
`;

export const SolutionEditLoader = styled.div`
  padding: 3.75rem;
  text-align: center;
`;

export const TextInputLabel = styled.label`
  position: relative !important;
  margin-bottom: -8px;
  margin-left: -7px;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: ${(props) => (props.error === "" ? "#1bace4" : "red")};
  position: absolute;
  text-transform: initial;
  left: 0.625rem;
  z-index: 1;
  width: auto;
  transition: transform 150ms ease-out, font-size 150ms ease-out;
  &::after {
    content: "*";
    color: #ea6457;
    font-weight: bold;
  }
`;

export const RequiredFieldDivError = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: Lato;
  line-height: 1;
  margin: 0;
  padding: 0;
  position: relative;
  white-space: nowrap;
  font-style: italic;
}
`;
